import Path from "../../services/paths";
import InnovationActions from "../actions/innovationActions";
import utils from "../common/utils";
import axios from "axios";
import { getCookie } from '../../util-functions/util-funtions';
import CustomToast from "../../util-functions/customToast";

class InnovationMiddleware {
  static createInnovationPromotion(
    innovationPromotionObj
  ) {
    const csrftoken = getCookie('csrftoken');
    let url = `${Path.INNOVATION}`;
    return dispatch => {
      dispatch(InnovationActions.innovationRequest());

      utils
        .get_token()
        .then(token => {
          axios({
            method: "POST",
            url: url,
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
              'X-CSRFToken': csrftoken
            },
            data: JSON.stringify(innovationPromotionObj)
          })
            .then(res => {
              console.log(res)
              if (res.status === 200) {
                dispatch(InnovationActions.innovationSuccessul(res.data));
              }
              else {
                dispatch(InnovationActions.innovationFailed('error'));
              }
            })
            .catch(error => {
              dispatch(InnovationActions.innovationFailed(error));
            });
        })
        .catch(error => {
          dispatch(InnovationActions.innovationFailed(error));
        });
    };
  }

  static getConsumerPromotionById(
    id
  ) {
    let url = `${Path.INNOVATION}${id}`;

    return dispatch => {
      dispatch(InnovationActions.getInnovationByIdRequest());

      utils
        .get_token()
        .then(token => {
          axios({
            method: "GET",
            url: url,
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`
            }
          })
            .then(res => {
              if (res.status === 200) {
                dispatch(InnovationActions.getInnovationByIdSuccessul(res.data));
              }
              else {
                dispatch(InnovationActions.getInnovationByIdFailed('error'));
              }
            })
            .catch(error => {
              dispatch(InnovationActions.getInnovationByIdFailed(error));
            });
        })
        .catch(error => {
          dispatch(InnovationActions.getInnovationByIdFailed(error));
        });
    };
  }

  static patchUpdateInnovation(
    id,
    data
  ) {
    const csrftoken = getCookie('csrftoken');
    let url = `${Path.INNOVATION}${id}/`;

    return dispatch => {
      dispatch(InnovationActions.updateInnovationRequest());

      utils
        .get_token()
        .then(token => {
          axios({
            method: "PATCH",
            url: url,
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
              'X-CSRFToken': csrftoken
            },
            data: JSON.stringify(data)
          })
            .then(res => {
              if (res.status === 200) {
                dispatch(InnovationActions.updateInnovationSuccessul(res.data));
              }
              else {
                dispatch(InnovationActions.updateInnovationFailed('error'));
              }
            })
            .catch(error => {
              dispatch(InnovationActions.updateInnovationFailed(error));
            });
        })
        .catch(error => {
          dispatch(InnovationActions.updateInnovationFailed(error));
        });
    };
  }

  static getInnovationList(
    pageNo,
    selectedCategory,
    selectedBrand,
    selectedMasterSku,
    selectedInnoStatus
  ) {
    let url = `${Path.INNOVATION}?`;

    if (pageNo) {
      url += `page=${pageNo}&`;
    }
    if (Array.isArray(selectedCategory)) {
      selectedCategory.forEach(element => {
        url += `category=${element}&`;
      });
    }
    if (Array.isArray(selectedBrand)) {
      selectedBrand.forEach(element => {
        url += `brand=${element}&`;
      });
    }
    if (Array.isArray(selectedMasterSku)) {
      selectedMasterSku.forEach(element => {
        url += `master_sku=${element}&`;
      });
    }
    if (Array.isArray(selectedInnoStatus)) {
      selectedInnoStatus.forEach(element => {
        url += `status=${element}&`;
      });
    }

    url = url.slice(0, -1);

    return dispatch => {
      dispatch(InnovationActions.getInnovationListRequest());

      utils
        .get_token()
        .then(token => {
          axios({
            method: "GET",
            url: url,
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`
            }
          })
            .then(res => {
              if (res.status === 200) {
                dispatch(InnovationActions.getInnovationListSuccessul(res.data));
              }
              else {
                dispatch(InnovationActions.getInnovationListFailed('error'));
              }
            })
            .catch(error => {
              dispatch(InnovationActions.getInnovationListFailed(error));
            });
        })
        .catch(error => {
          dispatch(InnovationActions.getInnovationListFailed(error));
        });
    };
  }

  static postInnovationVolume(
    innovationVolume
  ) {
    const csrftoken = getCookie('csrftoken');
    let url = `${Path.INNOVATION_VOLUME}`;
    return dispatch => {
      dispatch(InnovationActions.postInnovationVolumeRequest());

      utils
        .get_token()
        .then(token => {
          axios({
            method: "POST",
            url: url,
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
              'X-CSRFToken': csrftoken
            },
            data: JSON.stringify(innovationVolume)
          })
            .then(res => {
              console.log(res)
              if (res.status === 200) {
                dispatch(InnovationActions.postInnovationVolumeSuccess(res.data));
              }
              else {
                dispatch(InnovationActions.postInnovationVolumeFailed('error'));
              }
            })
            .catch(error => {
              dispatch(InnovationActions.postInnovationVolumeFailed(error));
            });
        })
        .catch(error => {
          dispatch(InnovationActions.postInnovationVolumeFailed(error));
        });
    };
  }

  static deleteInnovationPromotion(
    id
  ) {
    const csrftoken = getCookie('csrftoken');
    let url = `${Path.INNOVATION}${id}/`;
    return dispatch => {
      dispatch(InnovationActions.deleteInnovationPromotionRequest());

      utils
        .get_token()
        .then(token => {
          axios({
            method: "DELETE",
            url: url,
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
              'X-CSRFToken': csrftoken
            },
            data: JSON.stringify({ "guids": [id] })
          })
            .then(res => {
              console.log(res)
              if (res.status === 204) {
                dispatch(InnovationActions.deleteInnovationPromotionSuccess(res.data));
              }
              else {
                dispatch(InnovationActions.deleteInnovationPromotionFailed('error'));
              }
            })
            .catch(error => {
              CustomToast('error', 'Promotion deletion failed!');
              dispatch(InnovationActions.deleteInnovationPromotionFailed(error));
            });
        })
        .catch(error => {
          dispatch(InnovationActions.deleteInnovationPromotionFailed(error));
        });
    };
  }

  static getRegionChannelSplitByMskuId(
    id
  ) {
    let url = `${Path.INNOVATION}${id}/get_split/`;

    return dispatch => {
      dispatch(InnovationActions.getRegionChannelSplitRequest());

      utils
        .get_token()
        .then(token => {
          axios({
            method: "GET",
            url: url,
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`
            }
          })
            .then(res => {
              if (res.status === 200) {
                dispatch(InnovationActions.getRegionChannelSplitSuccess(res.data));
              }
              else {
                dispatch(InnovationActions.getRegionChannelSplitFailed('error'));
              }
            })
            .catch(error => {
              dispatch(InnovationActions.getRegionChannelSplitFailed(error));
            });
        })
        .catch(error => {
          dispatch(InnovationActions.getRegionChannelSplitFailed(error));
        });
    };
  }

  static postRegionChannelSplit(
    id,
    data
  ) {
    const csrftoken = getCookie('csrftoken');
    let url = `${Path.BASE_URL}/innovation_split/${id}/post/`;
    return dispatch => {
      dispatch(InnovationActions.postRegionChannelSplitRequest());

      utils
        .get_token()
        .then(token => {
          axios({
            method: "POST",
            url: url,
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
              'X-CSRFToken': csrftoken
            },
            data: JSON.stringify(data)
          })
            .then(res => {
              if (res.status === 200) {
                dispatch(InnovationActions.postRegionChannelSplitSuccess(res.data));
              }
              else {
                dispatch(InnovationActions.postRegionChannelSplitFailed('error'));
              }
            })
            .catch(error => {
              dispatch(InnovationActions.postRegionChannelSplitFailed(error));
            });
        })
        .catch(error => {
          dispatch(InnovationActions.postRegionChannelSplitFailed(error));
        });
    };
  }
}

export default InnovationMiddleware;